import { RespCoachLogin } from "../models/RespCoachLogin";
import { IUser2 } from "../models/user copy";
import { EntitiesResponse } from "../pages/SelectEntityPage/SelectEntityPage";
import { MeState } from "../store/reducers/me";
import { IAxiosResponses } from "../typings/AxiosRespnses";

interface KeysStorageItem {
  me: MeState["me"];
  token: string;
  selectedDirector: MeState["selectedDirector"];
  coachMe: RespCoachLogin | undefined;
  selectedEntity: MeState["selectedEntity"];
  userMe: IAxiosResponses["userLogin"] | undefined;
}

export const getStorageItem = <T extends keyof KeysStorageItem>(key: T) => {
  const value = localStorage.getItem(key);
  if (value === null) return undefined;
  try {
    if (key === "token") return value as KeysStorageItem[T];
    return JSON.parse(value) as KeysStorageItem[T];
  } catch (error) {
    return undefined;
  }
};
export const setStorageItem = <T extends keyof KeysStorageItem>(
  key: T,
  value: KeysStorageItem[T]
) => {
  localStorage.setItem(
    key,
    typeof value === "string" ? value : JSON.stringify(value)
  );
};
export const removeStorageItem = <T extends keyof KeysStorageItem>(key: T) => {
  localStorage.removeItem(key);
};
